import { Button } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import { LayoutHeadings } from 'components/Layout/InnerLayout/LayoutHeadings/LayoutHeadings';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import sharedStyles from '../../Products.module.css';
import styles from './FlexiKreditProcess.module.css';

type TProps = {
  onApply: () => void;
};

export const FlexiKreditProcess = ({ onApply }: TProps) => {
  const { checkIntroducerPermission } = useIntroducerData();

  return (
    <div className={clsx(sharedStyles.section, styles.howItWorksSection)}>
      <LayoutHeadings
        heading={t`Process description`}
        headingVariant="long"
        headingAlignment="center"
      />

      <ul className={styles.steps}>
        <li className={styles.step}>
          <h3>
            1. <Trans>Submission of application</Trans>
          </h3>
          <p>
            <Trans>
              Enter your customer's details into the iwoca portal in 5 minutes
              and upload the required documents.
            </Trans>
          </p>
        </li>

        <li className={styles.step}>
          <h3>
            2. <Trans>Decision</Trans>
          </h3>
          <p>
            <Trans>
              Within 24 hours you'll receive a credit decision and the maximum
              amount your customer can draw down.
            </Trans>
          </p>
        </li>

        <li className={styles.step}>
          <h3>
            3. <Trans>Drawdown</Trans>
          </h3>
          <p>
            <Trans>
              Confirm the amount your customer wants to draw down and we'll
              guide them through the disbursement steps.
            </Trans>
          </p>
        </li>

        <li className={styles.step}>
          <h3>
            4. <Trans>Commission</Trans>
          </h3>
          <p>
            <Trans>
              Your commission is paid out as soon as your customer has received
              the loan.
            </Trans>
          </p>
        </li>
      </ul>

      <div className={styles.cta}>
        <Button
          variant="primary"
          disabled={!checkIntroducerPermission('can_create_applications')}
          onClick={onApply}
        >
          <Trans>Create a new app</Trans>
        </Button>
      </div>
    </div>
  );
};
